import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo/logo_original.png";
import ConcernsMenu from "./ConcernsMenu";
import { FaBuilding, FaBars, FaTimes } from "react-icons/fa";
import { ROOMS } from "../config/rooms";

function Header() {
  const [roomsOpen, setRoomsOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleOpenConcerns = () => {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("openConcernsMenu"));
    }
  };

  const isActive = (path) =>
    path === "/"
      ? location.pathname === "/"
      : location.pathname === path || location.pathname.startsWith(path + "/");

  const navLinkClass = (path) =>
    `hover:text-amber-200 transition-colors duration-300 ${isActive(path) ? "text-amber-200" : ""}`;

  return (
    <>
      <header className="relative z-[100] shadow-lg">
        <div className="absolute inset-0 bg-gradient-to-r from-amber-500 via-yellow-600 to-amber-900" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent pointer-events-none" />
        <nav className="relative container mx-auto px-3 md:px-4 py-1.5 md:py-2 flex items-center justify-between">
          <Link to="/" className="flex items-center drop-shadow-md">
            <img src={logo} alt="Logo" className="h-8 md:h-10 object-contain" />
          </Link>

          {/* Desktop Nav */}
          <ul className="hidden lg:flex items-center space-x-4 xl:space-x-5 text-white font-medium text-xs xl:text-sm drop-shadow-sm">
            <li>
              <Link to="/" className={navLinkClass("/")}>Home</Link>
            </li>
            <li
              className="relative"
              onMouseEnter={() => setRoomsOpen(true)}
              onMouseLeave={() => setRoomsOpen(false)}
            >
              <Link to="/rooms" className={navLinkClass("/rooms")}>Rooms +</Link>
              {roomsOpen && (
                <div className="absolute top-full left-0 pt-1 z-[110]">
                  <div className="bg-gray-900 rounded-lg shadow-xl border border-gray-700 min-w-[200px] py-1">
                    {ROOMS.map((room) => (
                      <Link
                        key={room.slug}
                        to={`/rooms/${room.slug}`}
                        className="block px-4 py-2.5 text-white hover:bg-amber-600 hover:text-white text-sm font-medium transition-colors whitespace-nowrap"
                      >
                        {room.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </li>
            <li>
              <Link to="/restaurant" className={navLinkClass("/restaurant")}>Restaurant</Link>
            </li>
            <li>
              <Link to="/conference" className={navLinkClass("/conference")}>Conference</Link>
            </li>
            <li>
              <Link to="/events" className={navLinkClass("/events")}>Events & Activities</Link>
            </li>
            <li>
              <Link to="/about" className={navLinkClass("/about")}>About</Link>
            </li>
            <li>
              <Link to="/contact" className={navLinkClass("/contact")}>Contact</Link>
            </li>
            <li>
              <button
                onClick={handleOpenConcerns}
                className="flex items-center gap-1.5 bg-white/95 hover:bg-white text-amber-900 font-semibold px-2.5 py-1 rounded-lg transition-all duration-300 text-xs whitespace-nowrap shadow-md hover:shadow-lg"
              >
                <FaBuilding className="text-xs flex-shrink-0" />
                <span>Our Concerns</span>
              </button>
            </li>
          </ul>

          {/* Mobile hamburger */}
          <button
            className="lg:hidden text-white text-xl p-1"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <FaTimes /> : <FaBars />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="lg:hidden relative bg-amber-900/95 backdrop-blur-sm border-t border-amber-700 px-4 py-3 z-[99]">
            <ul className="flex flex-col space-y-2 text-white font-medium text-sm">
              {[
                { to: "/", label: "Home" },
                { to: "/rooms", label: "Rooms +" },
                { to: "/restaurant", label: "Restaurant" },
                { to: "/conference", label: "Conference" },
                { to: "/events", label: "Events & Activities" },
                { to: "/about", label: "About" },
                { to: "/contact", label: "Contact" },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    onClick={() => setMobileOpen(false)}
                    className={`block py-2 px-3 rounded-lg hover:bg-amber-700 transition-colors ${isActive(to) ? "bg-amber-700" : ""}`}
                  >
                    {label}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  onClick={() => { handleOpenConcerns(); setMobileOpen(false); }}
                  className="w-full flex items-center gap-2 bg-white/95 text-amber-900 font-semibold px-3 py-2 rounded-lg text-sm"
                >
                  <FaBuilding />
                  <span>Our Concerns</span>
                </button>
              </li>
            </ul>
          </div>
        )}
      </header>

      <ConcernsMenu />
    </>
  );
}

export default Header;
